import { formatDate, lastDayOfMonth } from 'date-fns'
import { restApiKey, secondmentType } from '../../../_constants/Code'
import { PathInfoList } from '../../../_constants/PathInfoList'
import { errorLog } from '../../../common/logger/Logger'
import { getLatestStdFmtData } from '../../../common/utils/DataSetUtils'
import { getJsonObject } from '../../../common/utils/FileUtils'
import {
  convertFiscalPeriodToYear,
  extractMonthFromAccPeriod,
  getCurrentFiscalYear
} from '../../../pages/master/securitiesReportInfo/extra/helpers'
import { fetchLegalDisclosure, fetchMasterData } from '../../../pages/master/statutoryDisclosure/extra/services'
import { httpGet } from '../../../services/api/AmplifyApi'

/**
 * @function 年度から表示条件を取得
 * @param {[string, string]} yearDate 選択された年度の値とフィルド
 */
export const fetchFilter = async (dashboardId, props, args) => {
  try {
    const init = {
      queryStringParameters: {
        dashboardId: dashboardId || null,
        analysisMode: props.mode || null,
        parameters: JSON.stringify(
          // [field]: value?.replaceAll('度', '') || ''
          args
        )
      },
      headers: {}
    }

    const result = await httpGet(
      restApiKey.CHROFY_REST_API,
      PathInfoList.Resource.getQuickSightControlInfo(props.corporationNumber),
      init
    )

    if (!result) throw new Error('データがありません')

    return result
  } catch (error) {
    if (error?.response?.status !== 404) errorLog('E000001', '', 'quicksight', 'resetCondition', error)
  }
}

export const fetchLatestStdFmtData = async (props) => {
  const { bucketName, accPeriod } = props

  const res = await getLatestStdFmtData(bucketName, accPeriod)
  if (!res) return ''

  let latestYearMonth = res.monthData

  if (!/(\d{4})年(\d{1,2})月度/g.test(latestYearMonth)) latestYearMonth = ''

  return latestYearMonth
}

export const getMaxFiscalYear = (latestSetting, accPeriod) => {
  const currentFiscalYear = getCurrentFiscalYear(accPeriod)

  let limitFiscalYear = null

  if (latestSetting && latestSetting !== '未設定') {
    const latestFiscalYear = convertFiscalPeriodToYear(latestSetting, accPeriod, false)

    limitFiscalYear = Math.min(currentFiscalYear, latestFiscalYear)
  } else {
    limitFiscalYear = currentFiscalYear
  }

  return limitFiscalYear
}

/**
 * @function getStartAndEndOfFiscalPeriod
 * @param {number} fiscalYear
 * @param {number} accMonth
 */
export const getStartAndEndOfFiscalPeriod = (fiscalYear, accMonth) => {
  const startFiscalMonth = accMonth === 12 ? 0 : accMonth
  const endFiscalYear = accMonth === 12 ? fiscalYear : fiscalYear + 1
  const fiscalYearStartDate = new Date(fiscalYear, startFiscalMonth, 1)

  const fiscalYearEndDate = new Date(endFiscalYear, accMonth, 0) // 月の最終日 12/0 -> 12月31日

  return [fiscalYearStartDate, fiscalYearEndDate]
}

/**
 * @function fetchLatestFemaleManageRatioSecondmentType 最新女性管理職比率を取得
 * @param {object} props
 * @param {'Index-001' | 'Index-002' | 'Index-003'} secondmentTypeCode 女性管理職比率、育休取得率、賃金差異
 */
export const fetchLatestSecondmentType = async (props, secondmentTypeCode) => {
  const { accPeriod } = props

  const masterData = await fetchMasterData(props)
  let latestSetting = masterData?.LatestSettingFiscalYear

  const maxFiscalYear = getMaxFiscalYear(latestSetting, accPeriod)
  const accMonth = extractMonthFromAccPeriod(accPeriod)

  const [fiscalStartDate, fiscalEndDate] = getStartAndEndOfFiscalPeriod(maxFiscalYear, accMonth)

  const item = await fetchLegalDisclosure(props, fiscalStartDate, fiscalEndDate)

  if (!item) return ''

  return (item.legal_secondment || [])?.find((e) => e.index_code === secondmentTypeCode)?.secondment || ''
}

/** @function fetchSecondmentTypeOptionList フィルターの選択し表示を取得 */
export const fetchSecondmentTypeOptionList = () =>
  Object.entries(secondmentType).map(([k, v]) => ({
    ...v,
    key: k
  }))
